// extracted by mini-css-extract-plugin
module.exports = {"jcPrimary":"#41c8c3","jcPrimary700":"#32bbb5","jcGrey900":"#161f32","button":"ButtonAnchor__button"};